var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13008",
    d: "M160.909 98.864h4.545a3.409 3.409 0 0 0 3.409-3.409v-4.546a3.409 3.409 0 0 0-3.409-3.409h-4.545a3.409 3.409 0 0 0-3.409 3.409v4.545a3.409 3.409 0 0 0 3.409 3.409zm-1.136-7.955a1.136 1.136 0 0 1 1.136-1.136h4.545a1.136 1.136 0 0 1 1.136 1.136v4.545a1.136 1.136 0 0 1-1.136 1.136h-4.545a1.136 1.136 0 0 1-1.136-1.136z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-157.5 -87.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13009",
    d: "M370.909 98.864h4.545a3.409 3.409 0 0 0 3.409-3.409v-4.546a3.409 3.409 0 0 0-3.409-3.409h-4.545a3.409 3.409 0 0 0-3.409 3.409v4.545a3.409 3.409 0 0 0 3.409 3.409zm-1.136-7.955a1.136 1.136 0 0 1 1.136-1.136h4.545a1.136 1.136 0 0 1 1.136 1.136v4.545a1.136 1.136 0 0 1-1.136 1.136h-4.545a1.136 1.136 0 0 1-1.136-1.136z",
    transform: "translate(-353.864 -87.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13010",
    d: "M160.909 308.864h4.545a3.409 3.409 0 0 0 3.409-3.409v-4.545a3.409 3.409 0 0 0-3.409-3.409h-4.545a3.409 3.409 0 0 0-3.409 3.409v4.545a3.409 3.409 0 0 0 3.409 3.409zm-1.136-7.954a1.136 1.136 0 0 1 1.136-1.136h4.545a1.136 1.136 0 0 1 1.136 1.136v4.545a1.136 1.136 0 0 1-1.136 1.136h-4.545a1.136 1.136 0 0 1-1.136-1.136z",
    transform: "translate(-157.5 -283.864)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13011",
    d: "M370.909 308.864h4.545a3.409 3.409 0 0 0 3.409-3.409v-4.545a3.409 3.409 0 0 0-3.409-3.409h-4.545a3.409 3.409 0 0 0-3.409 3.409v4.545a3.409 3.409 0 0 0 3.409 3.409zm-1.136-7.954a1.136 1.136 0 0 1 1.136-1.136h4.545a1.136 1.136 0 0 1 1.136 1.136v4.545a1.136 1.136 0 0 1-1.136 1.136h-4.545a1.136 1.136 0 0 1-1.136-1.136z",
    transform: "translate(-353.864 -283.864)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/gridIcon.207f789b8eb9e0b0f8d84091f59f471b.svg";
export { ForwardRef as ReactComponent };